import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';
import { Media } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextMedia}
 */
const TextMedia = ({
    heading,
    link,
    media,
    modulePaddingClasses = '',
    text
}) => {
    const href = formatLinkBlockToUrl(link);

    return (
        <section className='module-text-media'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid gap-16 sm:gap-0'>
                    <div className='order-1 w-full sm:w-5/12 layout-grid-col'>
                        {heading && (
                            <h2 className='type-style-heading'>
                                {href ? (
                                    <a
                                        className='underline'
                                        href={href}>
                                        <span>{heading}</span>
                                    </a>
                                ) : (
                                    heading
                                )}
                            </h2>
                        )}

                        {text && (
                            <div
                                className='rich-text type-style-heading sm:w-[90%]'
                                dangerouslySetInnerHTML={{ __html: text }} />
                        )}
                    </div>

                    {media && (
                        <div className='order-2 w-full sm:w-7/12 layout-grid-col text-[0] leading-[0] tracking-normal'>
                            <figure className={media.videoEmbed ? '' : 'pointer-events-none select-none'}>
                                <Media
                                    image={media.image ? { ...media.image } : undefined}
                                    video={media.video ? {
                                        autoPlay: true,
                                        controls: false,
                                        loop: true,
                                        muted: true,
                                        ...media.video
                                    } : undefined}
                                    videoEmbed={media.videoEmbed ? { ...media.videoEmbed } : undefined} />
                            </figure>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TextMedia;
